import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { WebMessageStatus } from 'src/app/common/constants/webmessage-status.constants';
import { AbstractRtpCorrespondentConfigurationService } from '../abstraction/abstract.rtp-correspondent-configuration.service';
import { IRtpRespondentSettings } from '../../interfaces/configuration/rtp-respondent-settings.interface';
import { IRtpCorrespondentSettings } from '../../interfaces/configuration/rtp-correspondent-settings.interface';
import { IRtpStandaloneSettings } from '../../interfaces/configuration/rtp-standalone-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class MockRtpCorrespondentConfigurationService extends AbstractRtpCorrespondentConfigurationService {
  private getRtpRespondentSettingsJson = 'assets/mocks/configuration/getRtpRespondentSettings.json';
  private getRtpCorrespondentSettingsJson =
    'assets/mocks/configuration/getRtpCorrespondentSettings.json';

  constructor(private http: HttpClient) {
    super();
  }

  getRtpRespondentSettings(routingNumber: string): Promise<IRtpRespondentSettings | undefined> {
    return lastValueFrom(this.http.get<IRtpRespondentSettings>(this.getRtpRespondentSettingsJson));
  }

  updateRtpRespondentSettings(settings: IRtpRespondentSettings): Promise<IWebMessage | undefined> {
    return Promise.resolve({
      status: WebMessageStatus.Success,
      message: 'RTP respondent settings saved successfully.',
      object: null,
    } as IWebMessage);
  }

  getRtpCorrespondentSettings(
    routingNumber: string
  ): Promise<IRtpCorrespondentSettings | undefined> {
    return lastValueFrom(
      this.http.get<IRtpCorrespondentSettings>(this.getRtpCorrespondentSettingsJson)
    );
  }

  updateRtpCorrespondentSettings(
    settings: IRtpCorrespondentSettings
  ): Promise<IWebMessage | undefined> {
    return Promise.resolve({
      status: WebMessageStatus.Success,
      message: 'RTP correspondent settings saved successfully.',
      object: null,
    } as IWebMessage);
  }

  getRtpStandaloneSettings(routingNumber: string): Promise<IRtpStandaloneSettings | undefined> {
    return Promise.resolve({
      routingNumber: routingNumber,
      rtpFundingAccountId: '12345678901',
      rtpEnableAutomaticDisbursement: true,
      rtpHighWatermark: 500000,
      rtpLowWatermark: 100000,
    } as IRtpStandaloneSettings);
  }

  updateRtpStandaloneSettings(settings: IRtpStandaloneSettings): Promise<IWebMessage | undefined> {
    return Promise.resolve({
      status: WebMessageStatus.Success,
      message: 'RTP Funding Account Settings updated successfully.',
      object: null,
    } as IWebMessage);
  }
}
